import axiosInstance from "./axiosInstance";

// Get employee details by company ID and employee ID
export const getEmployeeDetails = (companyId, employeeId) => {
  return axiosInstance.get(
    `https://www.zapendhub.com/api/companies/${companyId}/employees/${employeeId}`
  );
};

// PATCH employee details
export const updateEmployeeDetails = (companyId, employeeId, payload) => {
  return axiosInstance.patch(
    `https://www.zapendhub.com/api/companies/${companyId}/employees/${employeeId}`,
    payload
  );
};
